import React, { useState } from "react";
import { useDispatch } from "react-redux";
import { toast } from "react-toastify";
import Header from "../../components/landingPage/Header";
import Footer from "../../components/landingPage/Footer";
import InputField from "../../components/b2b/InputField";
// import { NavLink } from "react-router-dom";
import DatePicker from "react-date-picker";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

import { setBookingDateChange } from "../../redux/app/booking/booking-slice";
import {
  faAddressCard,
  faCalendar,
  faClipboardList,
  faEnvelope,
  faPhone,
  faUser,
} from "@fortawesome/fontawesome-free-solid";
import { faUserGroup } from "@fortawesome/free-solid-svg-icons";

const initialState = {
  firstName: "",
  lastName: "",
  email: "",
  companyName: "",
  contactNumber: "",
  address: "",
};

const VipAssistance = () => {
  const dispatch = useDispatch();
  const [newUser, setnewUser] = useState(initialState);
  const [openService, setOpenService] = useState(false);
  const [openDatePicker, setopenDatePicker] = useState(false);
  const [dateValue, setDateValue] = useState();
  const [dateChange, setDateChange] = useState(undefined);

  const handleOpen = () => {
    setOpenService(!openService);
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setnewUser({ ...newUser, [name]: value });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    if (
      newUser.firstName === "" ||
      newUser.lastName === "" ||
      newUser.email === "" ||
      newUser.contactNumber === "" ||
      newUser.message === ""
    ) {
      toast.error("Please fill all the fields");
    } else {
      dispatch({ type: "REGISTER_MAIL", payload: newUser });
      setnewUser({
        firstName: "",
        lastName: "",
        email: "",
        contactNumber: "",
        message: "",
      });
    }
  };
  return (
    <>
      <div>
        <Header className="static" />
        <div className="relative">
          <img
            src={require("../../assets/images/login_landing.jpg")}
            alt=""
            className="hidden sm:block sm:h-[54rem] md:h-[51rem] lg:h-[50rem] xl:h-[51rem] w-screen object-cover"
          />

          {/* ------------------------------------ FOR SCREEN BELOW 640px --------------------------------------- */}
          <div className="bg-black sm:transparent sm:hidden w-screen h-[60rem] object-cover"></div>
          {/* ------------------------------------ FOR SCREEN BELOW 640px --------------------------------------- */}

          <div className="bg-gradient-to-r from-[#121518] to-[#322d2d] w-full h-full opacity-80 absolute top-0"></div>
          <div className="w-full absolute top-10">
            <div className="px-5 md:px-10 lg:px-44 xl:px-72 2xl:px-[26rem] text-left my-10 sm:my-16">
              <div className="bg-black rounded-lg p-6 sm:p-16 opacity-80 shadow-md">
                <h2 className="text-2xl sm:text-4xl text-center text-slate-300">
                  Need VIP Assistance at Airport?
                </h2>
                {/* <div className='bg-white border border-slate-200 p-16 shadow-md rounded-xl w-3/4'> */}
                <div className="w-full mt-10">
                  <h2 className="text-md sm:text-lg font-medium text-slate-300">
                    Meet & Assist Arrival & Departure
                  </h2>
                  <h4 className="text-[14px] font-thin sm:text-[15px] text-slate-400 mt-3">
                    With Our Fast Track VIP Service, Be greeted by our
                    representative at the aerobridge. From baggage handling,
                    lounge stays, fast track immigration channel; experience
                    hassle-free and seamless end to end airport experience.
                  </h4>
                  <div className="sm:flex sm:space-x-5 mt-2 sm:mt-0">
                    <div className="border-slate-400 border rounded-md mt-3 w-full">
                      <InputField
                        isFontawesome={true}
                        fontawesomeIcon={faUser}
                        placeholder="First name"
                        id="firstName"
                        name="firstName"
                        type="text"
                        value={newUser.firstName}
                        onChange={handleChange}
                      />
                    </div>
                    <div className="border-slate-400 border rounded-md mt-3 w-full">
                      <InputField
                        isFontawesome={true}
                        fontawesomeIcon={faUser}
                        placeholder="Last name"
                        id="lastName"
                        name="lastName"
                        type="text"
                        value={newUser.lastName}
                        onChange={handleChange}
                      />
                    </div>
                  </div>
                  <div className="sm:flex sm:space-x-5 mt-2 sm:mt-0">
                    <div className="border-slate-400 border rounded-md mt-3 w-full">
                      <InputField
                        isFontawesome={true}
                        fontawesomeIcon={faPhone}
                        placeholder="Contact Number"
                        id="contactNumber"
                        name="contactNumber"
                        type="text"
                        value={newUser.contactNumber}
                        onChange={handleChange}
                      />
                    </div>
                    <div className="border-slate-400 border rounded-md mt-3 w-full">
                      <InputField
                        isFontawesome={true}
                        fontawesomeIcon={faEnvelope}
                        placeholder="Email Address"
                        id="email"
                        name="email"
                        type="text"
                        value={newUser.email}
                        onChange={handleChange}
                      />
                    </div>
                  </div>
                  <div className="sm:flex sm:space-x-5 mt-2 sm:mt-0">
                    <div className="vipAssistance flex space-x-1 lg:space-x-0 items-center box-content bg-white border-slate-400 border rounded-md mt-3 w-full h-10 lg:h-[3.33rem]">
                      {/* <div className="text-sm font-semibold">Date</div> */}
                      <div className="sm:px-2 pl-3.5 sm:pl-4 lg:pl-2.5">
                        <FontAwesomeIcon
                          icon={faCalendar}
                          className="text-black w-6 sm:w-5 h-5 sm:h-5"
                        />
                      </div>
                      <DatePicker
                        className="flex items-center border-none text-gray-500 text-sm"
                        format="dd-MM-yy"
                        dayPlaceholder="DD"
                        monthPlaceholder="MM"
                        yearPlaceholder="YYYY"
                        minDate={new Date()}
                        // placeHolder="dd-mm-yy"
                        onChange={(e) => {
                          setDateValue(e);
                          // setDateChange(moment(e).format("yyyy-MM-DD"));
                          dispatch(
                            setBookingDateChange({
                              // dateChange: moment(e).format("yyyy-MM-DD"),
                            })
                          );
                        }}
                        value={dateValue}
                      />
                    </div>
                    <div className="relative mt-3 w-full">
                      <div className="flex items-center space-x-1 bg-white border-slate-400 text-gray-400 border rounded-md py-2 lg:px-2 lg:py-[14px] lg:w-full lg:h-full">
                        <div className="sm:px-1 pl-4 sm:pl-4 lg:pl-0">
                          <FontAwesomeIcon
                            icon={faClipboardList}
                            className="text-black w-5 h-5"
                          />
                        </div>
                        <button onClick={handleOpen}>Select Service</button>
                      </div>
                      {/* {openService ? <div>Is Open</div> : <div>Is Closed</div>} */}
                      <div className="absolute top-12 z-10 bg-white w-full h-auto rounded-bl-md rounded-br-md shadow-2xl overflow-y-auto text-primary text-base">
                        {openService ? (
                          <ul>
                            <li className="px-2 py-2 text-[15px] font-normal hover:bg-secondary hover:text-white">
                              <button>Arrival</button>
                            </li>
                            <li className="px-2 py-2 text-[15px] font-normal hover:bg-secondary hover:text-white">
                              <button>Departure</button>
                            </li>
                          </ul>
                        ) : null}
                      </div>
                    </div>
                  </div>

                  <div className="border-slate-400 border rounded-md mt-3 w-full">
                    <InputField
                      isFontawesome={true}
                      fontawesomeIcon={faAddressCard}
                      placeholder="Please share your complete requirement here.."
                      id="message"
                      name="message"
                      type="textarea"
                      value={newUser.message}
                      onChange={handleChange}
                    />
                  </div>
                  <div className="text-center mt-5">
                    <button className="bg-[#fb4156] text-white w-full py-3 rounded-md">
                      SUBMIT
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <Footer />
      </div>
    </>
  );
};

export default VipAssistance;
